module.exports = __webpack_public_path__ + "media/images/no-cover-369ad8f0ea82dde5923c942ba1a26482.png";